import React, { useState } from 'react';
import { useAuth } from '../AuthContext'; // Certifique-se de que este caminho está correto
import '../Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth(); // Obter o estado de autenticação do contexto

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  if (!isAuthenticated) {
    return (
      <header className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1 className="navbar-logo-text">ProcessStepWise.</h1>
          </div>

          <nav className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/contato">Contato</Link></li>
              <li><Link to="/pagamento">💳 Pagamento</Link></li>
              <li><Link to="/loginPage">Login</Link></li>
            </ul>
          </nav>

          <div className="navbar-mobile-icon" onClick={toggleMobileMenu}>
            <span className="menu-icon">&#9776;</span>
          </div>
        </div>
      </header>
    );
  }

  return null; // Não renderiza a navbar se o usuário estiver autenticado
};

export default Navbar;
